<template>
  <div class="subscription-selection">
    <!-- 订阅选择弹窗 -->
    <el-dialog
      :visible.sync="dialogBatchRenewal"
      width="720px"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      :before-close="preventClose"
      @closed="closeDialog"
      @open="openDialog"
      custom-class="subscription-dialog"
    >
      <!-- 主要内容区域 -->
      <div class="subscription-wrapper">
        <!-- 订阅选择（无TAB，双卡布局） -->
        <div v-if="!showResult">
          <!-- 产品标题 -->
          <h2 class="product-title">{{ $t("user.MachineRenewal.productTitle") }}</h2>
               <h3 class="product-description">{{ $t("user.MachineRenewal.productDescriptionLine1") }}
                <br/>
                {{ $t("user.MachineRenewal.productDescriptionLine2") }}     
               </h3>
          <!-- 设备数量与首次订阅提示 -->
          <p class="device-count" v-if="needRenewalCount > 0">
            {{ $t("user.MachineRenewal.deviceCount.prefix") }}
            <strong>{{ needRenewalCount }}</strong>
            {{ $t("user.MachineRenewal.deviceCount.selectedForActivation") }}
          </p>
          <p class="no-devices-warning" v-if="needRenewalCount === 0">
            <i class="el-icon-warning"></i>
            {{ $t("user.MachineRenewal.noDevicesWarning") }}
          </p>

          <!-- Trial notice -->
          <div class="trial-notice">
            <span class="trial-notice__icon"><i class="el-icon-warning"></i></span>
            <span>{{ $t("header.expireSummaryDesc") }}</span>
          </div>

          <!-- <div class="first-time-notice" v-if="needRenewalCount > 0 && hasFirstTimeNewDevices">
            <p>
              {{
                $t(
                  firstTimeNewDevicesCount > 1
                    ? "user.MachineRenewal.firstTimeNotice.line1.plural"
                    : "user.MachineRenewal.firstTimeNotice.line1.single",
                  { count: firstTimeNewDevicesCount }
                )
              }}
            </p>
            <p>{{ $t("user.MachineRenewal.firstTimeNotice.line2") }}</p>
          </div> -->

          <!-- 双卡选择 -->
          <div class="cards-container">
            <!-- 月付卡片 -->
            <div class="subscription-card">
              <span class="popular-badge">Most popular</span>
              <div class="plan-name">{{ $t("user.MachineRenewal.tab.monthly") }}</div>
              <div class="price">${{ getPerDeviceAmount('monthly') }}<span>/{{ $t("user.MachineRenewal.period.month") }}</span>
              </div>
              <button
                class="subscribe-btn"
                :disabled="needRenewalCount === 0"
                @click="openPaymentDialog('monthly')"
              >
                {{ $t("user.MachineRenewal.button.subscribe") }}
              </button>
            </div>

            <!-- 年付卡片 -->
            <div class="subscription-card">
              <span class="savings-badge" v-if="savingsPercentage > 0">Save {{ savingsPercentage }}%</span>
              <div class="plan-name">{{ $t("user.MachineRenewal.tab.yearly") }}</div>
              <div class="price">${{ getPerDeviceAmount('yearly') }}<span>/{{ $t("user.MachineRenewal.period.year") }}</span>
              </div>
              <button
                class="subscribe-btn"
                :disabled="needRenewalCount === 0"
                @click="openPaymentDialog('yearly')"
              >
                {{ $t("user.MachineRenewal.button.subscribe") }}
              </button>
            </div>
          </div>
        </div>

        <!-- 支付结果页面 -->
        <div v-if="showResult" class="result-section">
          <div class="result-icon">
            <i :class="resultIcon" :style="{ color: resultColor }"></i>
          </div>
          <h3 class="result-title">{{ getResultTitle() }}</h3>
          <p class="result-message">{{ getResultMessage() }}</p>
        </div>
      </div>

      <!-- 底部操作区域 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('')">
          {{ $t('common.close') }}
        </el-button>
        <el-button type="primary" v-if="showResult" @click="handleComplete">
          {{ $t("user.MachineRenewal.footer.complete") }}
        </el-button>
      </div>
    </el-dialog>

    <!-- 续费详情弹窗 -->
    <el-dialog
      :title="$t('user.MachineRenewal.456993-17')"
      :visible.sync="dialogTableVisible"
      width="700px"
      :modal-append-to-body="true"
      :append-to-body="true"
    >
      <el-table :data="xufeiList" border>
        <el-table-column prop="equipmentName" :label="$t('user.MachineRenewal.456993-18')"></el-table-column>
        <el-table-column prop="equipmentNo" :label="$t('user.MachineRenewal.456993-19')" width="300"></el-table-column>
        <el-table-column prop="rentPrice" :label="$t('user.MachineRenewal.456993-20')" width="120" align="center">
          <template slot-scope="scope"> <span class="vtm-num">${{ scope.row.rentPrice }}</span> </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 新增：支付方式选择弹窗 -->
    <el-dialog
      :visible.sync="showPaymentMethodDialog"
      width="600px"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
    >
       <div style="padding:16px;text-align:center;">

       <h3 style="font-size:18px;margin:0 0 12px 0;line-height:1.4;word-break:keep-all;">{{ $t('user.MachineRenewal.paymentDialog.title', { count: needRenewalCount, freq: frequencyPaymentsLabel }) }}</h3>
       
       <!-- Total Price Display -->
       <div style="margin:20px 0;padding:16px;background:var(--vtm-well);border-radius:8px;">
         <div style="font-size:14px;color:var(--vtm-ink-2);margin-bottom:8px;">Total Amount</div>
         <div style="font-size:28px;font-weight:700;color:var(--vtm-ink);">${{ getOrderAmount(selectedFrequency) }}</div>
         <div style="font-size:13px;color:var(--vtm-ink-2);margin-top:4px;">${{ getPerDeviceAmount(selectedFrequency) }} per device</div>
       </div>
       </div>
       <!-- 提示新设备信息 -->
            <div class="first-time-notice" v-if="needRenewalCount > 0 && hasFirstTimeNewDevices">
            <p>
              {{
                $t(
                  firstTimeNewDevicesCount > 1
                    ? "user.MachineRenewal.firstTimeNotice.line1.plural"
                    : "user.MachineRenewal.firstTimeNotice.line1.single",
                  { count: firstTimeNewDevicesCount }
                )
              }}
            </p>
            <!-- <p>{{ $t("user.MachineRenewal.firstTimeNotice.line2") }}</p> -->
          </div>
       <span slot="footer" class="dialog-footer payment-dialog-footer">

       <!-- 可选取消按钮保留为次要，不改变居中效果 -->
      <!-- <el-button @click="cancelPaymentMethodDialog">{{ $t('user.MachineRenewal.paymentDialog.cancel') }}</el-button> -->
      <el-button type="primary" class="confirm-btn-large" :loading="confirmBtnLoading" :disabled="confirmBtnLoading" @click="useExistingPaymentMethod">
        {{ $t('user.MachineRenewal.paymentDialog.confirm') }}
      </el-button>
       </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "MachineRenewal",
    props: {
      dialogBatchRenewal: Boolean,
      renewalList: Array,
      nickName: String,
      confirmRenew: Object,
      oldStepsActive: {
        type: Number,
        default: -1
      },
      orderNumber: {
        type: String,
        default: ""
      },
      result: {
        type: String,
        default: "el-icon-info"
      },
      resultText: {
        type: String,
        default: ""
      },
      process: {
        type: String,
        default: "process"
      },
      oldState: {
        type: Number,
        default: -1
      }
    },
    data() {
      return {
        loading: false,
        dialogTableVisible: false,
        xufeiList: [],
        xufeiPrice: 0,
        orderId: "",
        stepsActive: 0,
        state: 0,
        paymentLoading: 0, // 支付按钮加载状态
        selectedFrequency: "monthly", // 选择的订阅频率: 'monthly' 或 'yearly'，默认月付
        showResult: false, // 是否显示结果页面
        allowClose: false, // 订阅成功后允许关闭弹窗
        orderAmount: null, // 后端返回的订单总金额
        orderAmountMonthly: null,
        orderAmountYearly: null,
        amountLoading: false,
        // 新增：支付方式选择弹窗与待处理的订阅类型
        showPaymentMethodDialog: false,
        confirmBtnLoading: false,
        pendingPaymentType: 1
      };
    },
    computed: {
      // 计算真正需要续费的机器数量（按是否存在 stripeSubscriptionId 判断是否已订阅）
      selectedRenewalList() {
        const list = Array.isArray(this.renewalList) ? this.renewalList : [];
        return list.filter(machine => {
          if (!machine) return false;
          const isSubscribed = !!machine.stripeSubscriptionId;
          return !isSubscribed;
        });
      },
      // 首次订阅新设备数量（仅统计本次需要订阅的设备列表）
      firstTimeNewDevicesCount() {
        const list = Array.isArray(this.selectedRenewalList) ? this.selectedRenewalList : [];
        return list.reduce((acc, m) => {
          const v = m && m.isTransferNew;
          return acc + (v === 1 || v === "1" || v === true ? 1 : 0);
        }, 0);
      },
      // 是否包含首次订阅（新设备）
      hasFirstTimeNewDevices() {
        return this.firstTimeNewDevicesCount > 0;
      },
      needRenewalCount() {
        return this.selectedRenewalList.length;
      },
      resultIcon() {
        switch (this.state) {
          case 1:
            return "el-icon-loading";
          case 2:
            return "el-icon-success";
          case 3:
            return "el-icon-error";
          default:
            return "el-icon-warning";
        }
      },
      resultColor() {
        switch (this.state) {
          case 1:
            return "#74d6b3";
          case 2:
            return "#67c23a";
          case 3:
            return "#f56c6c";
          default:
            return "#e6a23c";
        }
      },
      frequencyPaymentsLabel() {
        return this.selectedFrequency === 'yearly'
          ? this.$t('user.MachineRenewal.paymentDialog.yearlyPayments')
          : this.$t('user.MachineRenewal.paymentDialog.monthlyPayments');
      },
      // 计算年付相比月付的节省百分比
      savingsPercentage() {
        const monthly = parseFloat(this.orderAmountMonthly);
        const yearly = parseFloat(this.orderAmountYearly);
        
        if (isNaN(monthly) || isNaN(yearly) || monthly <= 0 || yearly <= 0) {
          return 0;
        }
        
        const yearlyFromMonthly = monthly * 12;
        const savings = yearlyFromMonthly - yearly;
        const percentage = (savings / yearlyFromMonthly) * 100;
        
        return Math.round(percentage);
      }
    },
    methods: {
      // 弹窗允许用户随时关闭
      preventClose(done) {
        try { done && done(); } catch (_) {}
        this.allowClose = false;
      },
      // 选择订阅频率
      selectFrequency(frequency) {
        if (this.paymentLoading > 0) return; // 支付中不允许切换
        this.selectedFrequency = frequency;
        // 频率切换后重新从后端获取订单总金额
        this.fetchRenewalCost();
      },

      // 展示订单总金额（支持区分月付/年付）
      getOrderAmount(freq) {
        const target = (freq === 'yearly' || freq === 2)
          ? (this.orderAmountYearly ?? this.orderAmount)
          : (this.orderAmountMonthly ?? this.orderAmount);
        if (target == null) return '0.00';
        const n = parseFloat(target);
        return isNaN(n) ? String(target) : n.toFixed(2);
      },

      // 展示每台设备金额（总金额 / 设备数量）
      getPerDeviceAmount(freq) {
        const total = this.getOrderAmount(freq);
        const count = this.needRenewalCount || 1;
        const perDevice = parseFloat(total) / count;
        return isNaN(perDevice) ? '0.00' : perDevice.toFixed(2);
      },

      // 调用后端计算订单金额（支持单独拉取月付/年付）
      async fetchRenewalCost(paymentTypeArg) {
        try {
          this.amountLoading = true;
          let paymentType = paymentTypeArg;
          if (paymentType == null) {
            paymentType = this.selectedFrequency === 'monthly' ? 1 : 2;
          }
          // 优先使用筛选后的未订阅设备；若为空则回退使用父组件传入的列表
          const baseList = (Array.isArray(this.selectedRenewalList) && this.selectedRenewalList.length > 0)
            ? this.selectedRenewalList
            : (Array.isArray(this.renewalList) ? this.renewalList : []);
          const equipmentIds = baseList
            .map(item => item && (item.id != null ? item.id : item.equipmentId))
            .filter(id => id != null);

          const res = await this.$api.request(
            this.$url.RenewalRecord.calculateCostRenewal,
            this.$method.post,
            { equipmentIds, stripeSubscriptionPayType: paymentType }
          );
          if (res && res.code === 0) {
            const total = res?.data?.totalPrice;
            if (total != null) {
              // 缓存两种价格，兼容原有 orderAmount
              if (paymentType === 1) this.orderAmountMonthly = total;
              else if (paymentType === 2) this.orderAmountYearly = total;
              this.orderAmount = total;
            } else {
              this.orderAmount = null;
              this.$message.error(this.$t("user.MachineRenewal.amountCalc.noTotal"));
            }
          } else {
            this.$message.error(res && res.msg ? res.msg : this.$t("user.MachineRenewal.amountCalc.failed"));
          }
        } catch (e) {
          this.$message.error(this.$t("user.MachineRenewal.amountCalc.failed"));
        } finally {
          this.amountLoading = false;
        }
      },

      // 处理订阅按钮点击（区分月付=1、年付=2，并区分loading）
      // async handleSubscribe(freq) {
      //   if (this.paymentLoading > 0) return; // 防止重复点击

      //   // 支持传入 'monthly'/'yearly' 或 1/2
      //   if (freq != null) {
      //     this.selectedFrequency = (freq === 1 || freq === 'monthly') ? 'monthly' : 'yearly';
      //   }
      //   const paymentType = (this.selectedFrequency === 'monthly' || freq === 1) ? 1 : 2;
      //   this.paymentLoading = paymentType;

      //   try {
      //     // 1) 先检查用户银行卡配置状态
      //     const state = await this.checkUserStripePayment();

      //     if (state === 1) {
      //       // 未配置银行卡，提示并跳转到绑定银行卡页面（Stripe Portal 或后端提供的设置入口）
      //       this.$message.warning(this.$t("user.MachineRenewal.noCardDetected"));
      //       await this.startCardSetupFlow();
      //       this.paymentLoading = 0;
      //       return;
      //     }

      //     // 正常：state === 0，弹窗提示并在“确定”时创建订单
      //     if (state === 0) {
      //       this.pendingPaymentType = paymentType;
      //       this.showPaymentMethodDialog = true;
      //       this.paymentLoading = 0; // 弹窗展示时，重置按钮 loading
      //       // 由弹窗中的操作继续后续流程
      //       return;
      //     }

      //     // 收款失败：state === 2，直接提示失败信息
      //     if (state === 2) {
      //       this.$message.error(this.$t("user.MachineRenewal.cardChargeFailed") || "银行卡收款失败");
      //       this.paymentLoading = 0;
      //       return;
      //     }

      //     // 其它状态视为异常，阻断流程并引导到绑卡/修复
      //     this.$message.error(this.$t("user.MachineRenewal.paymentMethodAbnormal"));
      //     await this.startCardSetupFlow();
      //     this.paymentLoading = 0;
      //     return;
      //   } catch (error) {
      //     this.$message.error(this.$t("user.MachineRenewal.456993-36"));
      //     this.paymentLoading = 0;
      //   }
      // },

      // 订阅前检查用户银行卡配置状态
      async checkUserStripePayment() {
        const res = await this.$api.request(this.$url.Stripe.checkPayment, this.$method.get, {});
        if (res && res.code === 0) {
          return res.data && typeof res.data.state === "number" ? res.data.state : 0;
        }
        // 接口异常时，默认阻断流程并提示
        this.$message.error(res && res.msg ? res.msg : this.$t("user.MachineRenewal.456993-37"));
        throw new Error("checkPayment failed");
      },

      // 跳转到订阅管理页面
      async gotoSubscriptionPage() {
        // 订阅成功后跳转到订阅列表页面（Subscribe.vue）
        // 路由规则参考 utils/index.js 的 routers(): path = route.path + "/" + url(route.component)
        // 因此 Subscribe.vue 通常对应的路径为 "/mywallet/subscribe"
        try {
          this.$router.push({ path: "/mywallet/subscribe" });
        } catch (error) {
          // 如果路由跳转失败则提示
          this.$message.error(this.$t("user.MachineRenewal.gotoSubscriptionPage.failed"));
        }
      },

      // 跳转到 Stripe 客户门户或绑定银行卡入口
      async redirectToStripePortal() {
        // 计算回跳URL：成功绑定银行卡后返回订阅页面
        const subPath = this.$router.resolve({ path: "/mywallet/subscribe" }).href;
        const returnUrl = `${window.location.origin}${subPath}`;

        // 优先尝试获取客户门户会话链接（传入 returnUrl 供后端创建 session 使用）
        try {
          const portal = await this.$api.request(this.$url.Stripe.machineGetUrl, this.$method.get, { returnUrl });
          const url = portal?.data?.url || portal?.data?.href || portal?.data;
          if (portal.code === 0 && url) {
            // 新开窗口打开银行卡管理页面，避免当前页跳转
            const win = window.open(url, "_blank");
            if (win && typeof win === "object") {
              try {
                win.opener = null;
              } catch (_) {}
            } else {
              // 若浏览器阻止弹窗，则回退为当前窗口跳转
              window.location.href = url;
            }
            return;
          }
        } catch (_) {
          // ignore
        }

        // 回退：尝试后端提供的添加 Stripe 流程入口（同样附带 returnUrl）
        try {
          const addRes = await this.$api.request(this.$url.Stripe.add, this.$method.get, { returnUrl });
          const addUrl = addRes?.data?.url || addRes?.data?.href || addRes?.data;
          if (addRes.code === 0 && addUrl) {
            const win = window.open(addUrl, "_blank");
            if (win && typeof win === "object") {
              try {
                win.opener = null;
              } catch (_) {}
            } else {
              window.location.href = addUrl;
            }
            return;
          }
        } catch (_) {
          // ignore
        }

        // 如果无法获取链接，给出指引
        this.$message.warning(this.$t("user.MachineRenewal.redirectPortal.unavailable"));
      },

      // 新增：只打开支付方式弹窗并记录频率
      openPaymentDialog(freq) {
        this.selectedFrequency = (freq === 'yearly' || freq === 2) ? 'yearly' : 'monthly';
        this.showPaymentMethodDialog = true;
      },
      // 处理支付选择（保持兼容性）：仅打开弹窗
      handlePaymentSelection(frequency) {
        this.openPaymentDialog(frequency);
      },

      // 创建续费订单
      async createRenewalOrder(paymentType) {
        // 只处理真正需要续费的机器（stripeSubscriptionPayType === null）
        // 兼容不同数据结构：优先使用 id，缺失时使用 equipmentId
        const equipmentIds = this.selectedRenewalList
          .map(item => item && (item.id != null ? item.id : item.equipmentId))
          .filter(id => id != null);
        const res = await this.$api.request(this.$url.RenewalRecord.insert, this.$method.post, {
          equipmentIds,
          stripeSubscriptionPayType: paymentType
        });

        if (res.code === 0) {
          this.orderNumber = res.data.orderNumber;
          this.orderId = res.data.id;
        } else {
          throw new Error(res.msg || this.$t("user.MachineRenewal.createOrderFailed"));
        }
      },

      // 直接跳转到支付页面
      async directPaymentRedirect(paymentType) {
        const res = await this.$api.request(this.$url.Stripe.create, this.$method.get, {
          orderId: this.orderId,
          orderType: "RENT_WEB",
          stripeSubscriptionPayType: paymentType
        });

        if (res && res.code === 0) {
          const payUrl = res?.data?.href || res?.data?.url || res?.data;
          if (payUrl) {
            // 在当前窗口跳转到支付页面
            window.location.href = payUrl;
            return;
          }
        }

        // 未能获取到支付链接，尝试引导用户去绑定/管理银行卡
        this.$message.error(this.$t("user.MachineRenewal.directPaymentRedirect.payUrlError"));
        try {
          await this.startCardSetupFlow();
        } catch (_) {
          // ignore
        }
        this.paymentLoading = 0;
      },

      // 如未定义，提供开始绑卡流程入口
      startCardSetupFlow() {
        return this.redirectToStripePortal();
      },

      // 处理完成操作
      handleComplete() {
        this.showResult = false;
        this.$emit("cancelRenewal", false, "");
      },

      // 查看续费详情
      handleViewDetail() {
        this.dialogTableVisible = true;
      },

      // 弹窗打开
      openDialog() {
        // 重置状态
        this.selectedFrequency = "monthly"; // 默认选择月付
        this.showResult = false;
        this.paymentLoading = 0;
        this.allowClose = false;

        // 兼容旧版本参数 - 显示结果页面
        if (this.oldState > 0) {
          this.state = this.oldState;
          this.showResult = true;
        }

        // 预拉取两种价格用于左/右卡展示
        this.fetchRenewalCost(1);
        this.fetchRenewalCost(2);
      },

      // 弹窗关闭
      closeDialog() {
        this.selectedFrequency = "monthly";
        this.showResult = false;
        this.paymentLoading = 0;
        this.cancel("");
      },

      // 取消操作
      cancel(state) {
        this.$emit("cancelRenewal", false, state);
      },

      // 更新结果状态
      updateResultStatus() {
        switch (this.state) {
          case 1:
            this.resultText = this.$t("user.MachineRenewal.456993-25");
            break;
          case 2:
            this.resultText = this.$t("user.MachineRenewal.456993-26");
            break;
          case 3:
            this.resultText = this.$t("user.MachineRenewal.456993-27");
            break;
          default:
            this.resultText = this.$t("user.MachineRenewal.456993-28");
        }
      },

      // 获取续费状态
      rentState() {
        this.updateResultStatus();
      },

      // 获取结果标题
      getResultTitle() {
        switch (this.state) {
          case 1:
            return this.$t("user.MachineRenewal.456993-29");
          case 2:
            return this.$t("user.MachineRenewal.456993-30");
          case 3:
            return this.$t("user.MachineRenewal.456993-31");
          default:
            return this.$t("user.MachineRenewal.456993-28");
        }
      },

      // 获取结果消息
      getResultMessage() {
        switch (this.state) {
          case 1:
            return this.$t("user.MachineRenewal.456993-32");
          case 2:
            return this.$t("user.MachineRenewal.456993-33");
          case 3:
            return this.$t("user.MachineRenewal.456993-34");
          default:
            return this.$t("user.MachineRenewal.456993-35");
        }
      },

      // 获取续费结果内容（保持兼容性）
      renewalContent() {
        return this.getResultMessage();
      },

      // 支付方式弹窗“确认”按钮：检查绑卡状态并按要求处理
      async useExistingPaymentMethod() {
        const paymentType = this.selectedFrequency === 'yearly' ? 2 : 1;
        this.confirmBtnLoading = true;
        try {
          const state = await this.checkUserStripePayment();

          if (state === 1) {
            // 未配置银行卡：提示并跳转到绑定银行卡页面
            this.$message.warning(this.$t("user.MachineRenewal.noCardDetected"));
            await this.redirectToStripePortal();
            return;
          }

          if (state === 0) {
            // 已配置银行卡：创建订单并跳转到订阅页面
            await this.createRenewalOrder(paymentType);
            // 关闭两个弹窗（支付方式弹窗 + 订阅选择弹窗）
            this.showPaymentMethodDialog = false;
            try { this.$emit && this.$emit('cancelRenewal', false, true); } catch (_) {}
            await this.gotoSubscriptionPage();
            return;
          }

          if (state === 2) {
            // 收款失败：提示失败信息
            this.$message.error(this.$t("user.MachineRenewal.cardChargeFailed") || "银行卡收款失败");
            return;
          }

          // 其它状态：视为异常
          this.$message.error(this.$t("user.MachineRenewal.paymentMethodAbnormal"));
        } catch (e) {
          this.$message.error(this.$t("user.MachineRenewal.456993-36"));
        } finally {
          this.confirmBtnLoading = false;
        }
      },

      // 添加新的支付方式（跳转到绑卡流程）
      async addNewPaymentMethod() {
        try {
          await this.startCardSetupFlow();
        } catch (_) {
          // ignore
        } finally {
          this.showPaymentMethodDialog = false;
          this.paymentLoading = 0;
        }
      },

      // 取消支付方式选择
      cancelPaymentMethodDialog() {
        this.showPaymentMethodDialog = false;
        this.paymentLoading = 0;
      }
    }
  };
</script>

<style scoped lang="scss">
  /* 订阅选择弹窗样式 */
  .subscription-selection {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial,
      sans-serif;
  }

  /* 主容器 */
  .subscription-wrapper {
    padding: 0;
    min-height: 400px;
  }

  /* 顶部标签切换 */
  .subscription-tabs {
    width: 250px;
    margin: 0 auto;
    display: flex;
    background: var(--vtm-well);
    border-radius: 8px;
    padding: 4px;
    gap: 4px;
    margin-bottom: 30px;
    justify-content: center;
  }

  .tab-btn {
    padding: 12px 32px;
    border: none;
    border-radius: 8px;
    background: transparent;
    color: var(--vtm-ink-2);
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    min-width: 120px;
  }

  .tab-btn.active {
    background: var(--vtm-mint);
    color: var(--vtm-surface);
    box-shadow: 0 2px 8px rgba(43, 124, 233, 0.3);
  }

  .tab-btn:hover:not(.active) {
    color: var(--vtm-ink-2);
  }

  /* 订阅卡片 */
  .subscription-card {
    background: var(--vtm-well);
    border-radius: 16px;
    padding: 40px;
    position: relative;
    border: 1px solid var(--vtm-line);
  }

  /* Most popular 标签 */
  .popular-badge {
    position: absolute;
    top: 16px;
    left: 16px;
    display: inline-block;
    background: var(--vtm-surface);
    color: var(--vtm-ink-2);
    border-radius: 4px;
    padding: 4px 12px;
    font-size: 12px;
    font-weight: 500;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  /* Savings 标签 */
  .savings-badge {
    position: absolute;
    top: 16px;
    left: 16px;
    display: inline-block;
    background: var(--vtm-ok);
    color: var(--vtm-surface);
    border-radius: 4px;
    padding: 4px 12px;
    font-size: 12px;
    font-weight: 600;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  }

  /* 产品标题 */
  .product-title {
    font-size: 24px;
    font-weight: 700;
    color: var(--vtm-ink);
    margin: 16px 0 12px 0;
    line-height: 1.2;
  }

  /* 产品描述 */
  .product-description {
    font-size: 14px;
    color: var(--vtm-ink-2);
    line-height: 1.5;
    margin: 0 0 20px 0;
  }

  /* 设备数量提示 */
  .device-count {
    font-size: 14px;
    color: var(--vtm-ink-2);
    margin: 0 0 20px 0;
    padding: 10px 16px;
    background: var(--vtm-well);
    border-radius: 6px;
    border-left: 3px solid var(--vtm-mint);
    word-break: keep-all;
  }

  .device-count strong {
    color: var(--vtm-mint-ink);
    font-weight: 600;
  }

  /* 已选设备列表 */
  .selected-devices {
    margin: 8px 0 16px;
    padding-left: 18px;
    color: var(--vtm-ink-2);
    font-size: 13px;
  }
  .selected-devices li {
    line-height: 1.6;
  }

  /* 首次订阅提示（新设备） */
  .first-time-notice {
    margin: 0 0 20px 0;
    padding: 12px 16px;
    background: var(--vtm-surface);
    border: 1px solid var(--vtm-line);
    border-radius: 8px;
    color: var(--vtm-ink);
    font-size: 14px;
    line-height: 1.6;
    position: relative;
  }
  .first-time-notice::after {
    content: "";
    position: absolute;
    top: 8px;
    right: 8px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--vtm-line);
  }

  /* 试用期提示 */
  .trial-notice {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0 0 20px 0;
    padding: 12px 16px;
    background: var(--vtm-crit-soft);
    border-radius: 8px;
    border: 1px solid var(--vtm-crit-soft);
    font-size: 14px;
    line-height: 1.5;
    color: var(--vtm-ink-2);
  }

  .trial-notice__icon {
    flex-shrink: 0;
    width: 26px;
    height: 26px;
    background: var(--vtm-crit);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      color: var(--vtm-surface);
      font-size: 13px;
    }
  }

  /* 无设备警告 */
  .no-devices-warning {
    font-size: 14px;
    color: var(--vtm-warn);
    margin: 0 0 20px 0;
    padding: 10px 16px;
    background: var(--vtm-warn-soft);
    border-radius: 6px;
    border-left: 3px solid var(--vtm-warn);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }
  .plan-name{
     margin-left: 35%;
      font-size: 12px;
      line-height: 1;
    font-size: 14px;
    color: var(--vtm-ink);
    font-weight: 500;
  }

  /* 价格区域 */
  .price-section {
    display: flex;
    align-items: center;
    .period {
      display: flex;
      flex-direction: column;
      font-size: 12px;
      line-height: 1;
    }
  }

  .price {
    width: 300px;
    margin-top: 20px;
    font-size: 20px;
    font-weight: 800;
    color: var(--vtm-ink);
    margin-left: 15%;
  }

  .period {
    font-size: 14px;
    color: var(--vtm-ink-2);
    font-weight: 500;
  }

  .price-detail {
    font-size: 12px;
    color: var(--vtm-ink-2);
    margin-top: 10px;
    text-align: center;
    line-height: 1.4;
  }

  /* 订阅按钮 */
  .subscribe-btn {
    width: 100%;
    background: var(--vtm-mint);
    color: var(--vtm-surface);
    border: none;
    border-radius: 10px;
    padding: 14px 24px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    margin: 20px 0;
    position: relative;
    overflow: hidden;
  }

  .subscribe-btn:hover:not(:disabled) {
    background: var(--vtm-mint-dim);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(43, 124, 233, 0.3);
  }

  .subscribe-btn:disabled {
    background: var(--vtm-line);
    color: var(--vtm-ink-2);
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }

  /* 加载动画 */
  .loading-spinner {
    display: inline-block;
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top-color: var(--vtm-surface);
    animation: spin 1s ease-in-out infinite;
    margin-right: 8px;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  /* 提示信息 */
  .tip-info {
    margin-top: 15px;
    font-size: 12px;
    color: var(--vtm-ink-2);
    line-height: 1.5;
  }

  .tip-info p {
    margin: 4px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }

  .tip-info i {
    color: var(--vtm-mint-ink);
  }

  /* 结果页面 */
  .result-section {
    text-align: center;
    padding: 40px 20px;
  }

  .result-icon {
    margin-bottom: 20px;
  }

  .result-icon i {
    font-size: 48px;
  }

  .result-title {
    font-size: 20px;
    font-weight: 600;
    color: var(--vtm-ink);
    margin: 0 0 12px 0;
  }

  .result-message {
    font-size: 14px;
    color: var(--vtm-ink-2);
    line-height: 1.5;
    margin: 0;
  }

  /* 底部按钮区域 */
  .dialog-footer {
    text-align: right;
    padding: 15px 0 0 0;
  }

  /* 左右卡片容器：双卡并排 */
  .cards-container {
    display: flex;
    column-gap: 16px;
    row-gap: 16px;
    align-items: stretch;
    justify-content: space-between;
    flex-wrap: nowrap;
  }
  .cards-container .subscription-card {
    flex: 1 1 0;
    min-width: 0;
  }
</style>

<!-- 全局样式覆盖 el-dialog -->
<style>
  .subscription-dialog .el-dialog {
    border-radius: 16px;
    overflow: hidden;
  }

  .subscription-dialog .el-dialog__header {
    display: none;
  }

  .subscription-dialog .el-dialog__body {
    padding: 20px;
  }

  .subscription-dialog .el-dialog__footer {
    padding: 0 20px 20px 20px;
  }
.payment-dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
}
.confirm-btn-large {
  min-width: 240px;
  height: 44px;
  font-size: 16px;
  padding: 0 28px;
}
</style>
